/**
 * products-by-author.js.liquid
 * 
 * Global Javascript object for building
 * "other products by this author" slider widget.
 * 
 * Slider template: snippets/author-products-widget.liquid 
 */
window.productsByAuthor = {
  productId: false,
  productSku: false,
  productName: false,
  productAuthor: false,
  productCardsUnavailable: [],

  init: function() {
    const self = this;
    self.initFields();
    if (!self.productAuthor) {
      return;
    }
    self.fetchProductsByAuthor();
  },

  initFields: function() {
    const self = this;
    self.productAuthor = document.querySelector('#sk-product-data #sk-product-author').dataset.author;
    if (!self.productAuthor) {
      return;
    }
    
    self.productId = document.querySelector('#sk-product-data #sk-product-id').dataset.id;
    self.productSku = document.querySelector('#sk-product-data #sk-product-sku').dataset.sku;
    self.productName = document.querySelector('#sk-product-data #sk-product-title').dataset.title;
    self.productAuthor = document.querySelector('#sk-product-data #sk-product-author').dataset.author;
  },

  fetchProductsByAuthor: function() {
    const self = this;

    if (typeof self.productAuthor !== 'string') {
      return null;
    }

    // If more than one author use only the first one on the list
    let authorName = self.productAuthor.split('/')[0].trim(),
        tagStr = 'kirjoittaja:' + authorName.replace(/\p{P}/gu, '-').replace(/\s+/g, '-').toLowerCase(),
        url = window.location.origin + '/collections/all/' + tagStr + '?page=1&sort_by=best-selling';

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      success: function(html) {
        const productGrid = $(html).find('#MainContent .product-grid');
        if (productGrid.length > 0) {
          const productCards = productGrid.find('.card.product');
          if (!productCards || productCards.length < 4) {
            console.log('Could not fetch author products');
            return;
          }
          productCards.each(function() {
            self.createSliderElement($(this), authorName);
          });

          if (self.productCardsUnavailable.length > 0) {
            // Add unavailable products to the end of the slider
            self.productCardsUnavailable.forEach(function(card) {
              document.getElementById('author-products-list').appendChild(card);
            });
          }

          self.initAuthorProductsWidget();
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(textStatus);
      }
    });
  },

  createSliderElement: function(productCard, authorName) {
    /**
     * create a product slider element
     * and append it to #author-products-list
     */
    const self = this,
          sku = productCard.data('product-sku');

    if (sku == self.productSku) {
      // This is the same product as the main product. Skip. 
      return;
    }

    let title = productCard.find('.product-title span').text().trim(),
        price = productCard.find('.price').find('.on-sale').text().trim() || productCard.find('.price').text().trim(),// If product is on sale, get the sale price
        thumbnail = productCard.find('.image-link'),
        urlLink = productCard.find('a').first().attr('href'),
        priceHtml = productCard.find('.price')[0].innerHTML,
        buttonLabel, cardButton, shopifyVariantId, gtmCategory, frosmoCategory, dimension4, compareAtPrice,
        compareAtPriceHtml, loyaltyPrice, loyaltyPriceHtml, handle, handleHtml,
        cardForm = productCard.find('form'),
        dataInput,
        productNotAvailable = false;

    if (cardForm.length === 0) {
      productNotAvailable = true;
      // Product is not available for purchase
      cardForm = productCard.find('.button.add-to-cart');
      buttonLabel = cardForm[0].innerHTML;
      cardButton = '<span class="button small add-to-cart disabled">' + buttonLabel + '</span>';
    } else {
      // Product is available for purchase
      shopifyVariantId = productCard.find('[name="id"]')[0];      
      dataInput = productCard.find('#' + shopifyVariantId.value)[0];// Get hidden input with product data
      handle = productCard.find('[name="properties[_handle]"]')[0];
      handleHtml = '';
      if (typeof handle !== "undefined") {
        handleHtml = '<input type="hidden" name="properties[_handle]" value="'+ handle.value +'" />';
      }
      buttonLabel = productCard.find('.button.add-to-cart')[0].value;
      gtmCategory = productCard.find('[name="properties[_gtm_category]"]')[0].value;        
      frosmoCategory = productCard.find('[name="properties[_frosmo_category]"]')[0].value;
      dimension4 = productCard.find('[name="properties[_dimension4]"]')[0].value;
      compareAtPrice = productCard.find('[name="properties[_compare_at_price]"]')[0];
      if (typeof compareAtPrice !== "undefined") {
        compareAtPriceHtml = '<input type="hidden" name="properties[_compare_at_price]" value="' + compareAtPrice.value + '" data-compare-at-price-input />';
      } else {
        compareAtPriceHtml = '';
      }
      loyaltyPrice = productCard.find('[name="properties[_loyalty_price]"]')[0];
      if (typeof loyaltyPrice !== "undefined") {
        loyaltyPriceHtml = '<input type="hidden" name="properties[_loyalty_price]" value="' + loyaltyPrice.value + '" data-loyalty-price-input />';
      } else {
        loyaltyPriceHtml = '';
      }
      //Product must have a variant id to be added to cart
      if (typeof shopifyVariantId === "undefined") {
        productNotAvailable = true;
        cardButton = '<span class="button small add-to-cart disabled">' + buttonLabel + '</span>';
      } else {
        cardButton = '<form method="post" action="/cart/add">'+ compareAtPriceHtml + loyaltyPriceHtml +
        '<input type="hidden" name="properties[_gtm_category]" value="'+ gtmCategory +'" />'+
        '<input type="hidden" name="properties[_frosmo_category]" value="'+ frosmoCategory +'" />'+
        '<input type="hidden" name="properties[_dimension4]" value="'+ dimension4 +'" />'+
        '<input type="hidden" name="quantity" value="1" min="1">'+
        '<input type="hidden" name="id" value="'+ shopifyVariantId.value +'" />'+ handleHtml + 
        dataInput.outerHTML +
        '<input onclick="Shopify.analytics.publish(\'ecommerce_addtocart\',{\
          event: \'Ecommerce add to cart\',\
          ecommerce: {\'currencyCode\': \'EUR\',\'add\': {\
            products: [{\
              name: \'' + title + '\',\
              id: \'' + sku + '\', \
              price: \'' + price + '\',\
              author: \'' + authorName + '\',\
              quantity: 1 }]}}});"\
        type="submit" value="' + buttonLabel + ' " class="button small primary add-to-cart" \
        data-gtmvalue="product page | author other products | add to cart button | ' + sku + '" \
        aria-label="' + buttonLabel + ' ' + title + ' ' + price + '"/>'+
        '</form>'
      }
    }
    
    let authorOtherProduct = document.createElement('div');
    authorOtherProduct.className = 'authorOtherProduct cell';

    let productCardAriaLabel = "Siirry tuotteen sivulle" + ' ' + title;

    let htmlStr =
    '<div class="card product flex-container flex-dir-column" data-attr-hide-details="false">'+
    '<a onclick="Shopify.analytics.publish(\'product_click\',{\
      event: \'Ecommerce product listing click\',\
      eventDescription: \'product listing click\',\
      ecommerce: { click: {actionField: {list:\ \'Author other products on product card\'},\
      products: [{\
      name: \'' + title + '\',\
      id: \'' + sku + '\',\
      price: \'' + price + '\',\
      author: \'' + authorName + '\'}]}}});"\
    href="' + urlLink + '" class="image-link portrait" tabindex="0" aria-label="'+ productCardAriaLabel + '"><div class="card-image flex-container align-bottom align-center">'+ thumbnail[0].innerHTML +
    '</div></a>' + '<div class="options-only-phone">' +
    '<div class="card-content flex-container flex-dir-column">'+
    '<p class="product-title">' + title +
    '</p>'+
    '<div class="card-actions">'+
    '<p class="additional-data flex-container align-bottom">'+       
    '</p>'+ '<p class="price flex-container align-middle">'+ priceHtml + '</p>'+ cardButton +
    '</div>'+
    '</div>';
          
    authorOtherProduct.innerHTML = htmlStr;

    if (productNotAvailable) {
      // Add to unavailable products list
      self.productCardsUnavailable.push(authorOtherProduct);
      return;
    }

    document.getElementById('author-products-list').appendChild(authorOtherProduct);
  },

  initAuthorProductsWidget: function() {
    //Initiliaze and unhide #author-products-widget slider
    document.getElementById('author-products-list').classList.add("product-slider");
    document.getElementById('author-products-widget').setAttribute("style", "display: block !important;");
    let accessibilitySlideLeft = document.querySelector("#accessibilityStrings").getAttribute("data-slide-left");
	  let accessibilitySlideRight = document.querySelector("#accessibilityStrings").getAttribute("data-slide-right");
    $('#author-products-list').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      mobileFirst: true,
      autoplay: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      prevArrow: '<button type="button" aria-label="' + accessibilitySlideLeft + '" class="slick-prev unstyled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="444" d="M3.45 10c0-.2.1-.3.21-.5L13.19.2a.82.82 0 0 1 .52-.2c.2 0 .3.1.51.2l1 1a.72.72 0 0 1 .21.5c0 .2-.21.3-.31.4L7.14 10l8.1 7.86a.72.72 0 0 1 .21.5c0 .2-.1.3-.21.5l-1 1a.79.79 0 0 1-.51.2c-.21 0-.31-.1-.52-.2L3.66 10.55A.82.82 0 0 1 3.45 10Z"/></svg></button>',
      nextArrow: '<button type="button" aria-label="' + accessibilitySlideRight + '" class="slick-next unstyled"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 10.5 6.36 19.8a.82.82 0 0 1-.52.2c-.2 0-.3-.1-.51-.2l-1-1a.72.72 0 0 1-.21-.5c0-.2.1-.3.21-.5l8.1-7.9-8-7.8a.78.78 0 0 1-.21-.4 1.78 1.78 0 0 1 .21-.5l1-1A.82.82 0 0 1 5.84 0a.82.82 0 0 1 .52.2l9.53 9.3a.72.72 0 0 1 .21.5A.54.54 0 0 1 15.89 10.5Z"/></svg></button>',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }
      ]
    });      
  }
};

window.addEventListener('load', function() {
  window.productsByAuthor.init();
});